<template>
  <v-tooltip location="right">
    <template #activator="{ props }">
      <v-chip
        variant="flat"
        size="small"
        class="pointer-cursor chip-color"
        v-bind="props"
      >
        <div class="v-center padding">
          <v-icon size="20px" color="white" class="margin-icon"
            >mdi-arrow-up-bold-hexagon-outline</v-icon
          >
          <span class="font-weight-medium mr-1">{{
            $t('upselling.proFeature')
          }}</span>
        </div>
      </v-chip>
    </template>
    <span>{{ $t('upselling.limitedFunctionality') }}</span>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ProChip'
});
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
.padding {
  padding-bottom: 2px;
}
.margin-icon {
  margin-top: 2px;
  margin-right: 4px;
}
.chip-color {
  background: radial-gradient(ellipse, #0b75c5 0%, colors.$secondary 70%);
}
</style>
